import { useTranslation } from "../../../../../../hooks/useTranslation";
import { ITask } from "../../../../../../types/Task/Task.interface";
import { TaskStatus } from "../../../../../pages/Tasks/MyTasks/utils/constants";

interface IStatusHeader {
  tasks: ITask[];
}

export const StatusHeader: React.FC<IStatusHeader> = ({ tasks }) => {
  const { t } = useTranslation();
  if (!tasks.length) return <>{t("label.tasks-manager")}</>;

  let feedback = t("label.tasks-completed");
  const allTasks = tasks.length;
  const completedTasks = tasks.filter((task) => task.status === TaskStatus.COMPLETED).length;
  const isAllCompleted = tasks.every((task) => task.status === TaskStatus.COMPLETED);

  if (isAllCompleted) {
    feedback = `${allTasks} ${feedback}`;
  } else {
    feedback = `${completedTasks} ${feedback} ${t("label.out-of")} ${allTasks}`;
  }

  return <>{feedback}</>;
};
